const createActionConstants = (name, constants) => constants.reduce((acc, val) => ({
  ...acc,
  [val]: [name, val].join('/')
}), {})

export default createActionConstants
